import { useRouter } from "next/router"
import { useState } from "react"
import { H1, Input, P } from "../../components"
import Anchor from "../../components/anchor/anchor"
import Body from "../../components/body/body"
import { fetchApi } from "../../network/fetch"
import {
	BlackButton,
	ButtonIcon,
	CenterContainer,
	Form,
	Label,
} from "../../styles"

const ForgotPassword = () => {
	const router = useRouter()

	const [email, setEmail] = useState("")

	const _login = async (e) => {
		if (e) {
			e.preventDefault()
		}

		const result = await fetchApi("/users/resetpassword", { email }, "POST")
		if (result) {
			router.push("/forgot/confirmation")
		}
	}

	return (
		<Body>
			<CenterContainer width="500px">
				<H1>Forgot password</H1>
				<P style={{ alignSelf: "flex-start", marginBottom: "20px" }}>
					Know your password? <Anchor href="/login">Login!</Anchor>
				</P>

				<Form style={{ alignSelf: "stretch" }} onSubmit={_login}>
					<Label style={{ marginBottom: "5px" }}>
						Email
						<Input
							placeholder="Email"
							type="email"
							value={email}
							onChange={(value) => setEmail(value)}
						/>
					</Label>

					<BlackButton
						style={{ alignSelf: "center", marginTop: "50px" }}
						type="submit"
						disabled={email.length === 0}
					>
						<ButtonIcon
							src="/assets/images/arrowRight.svg"
							color="white"
							width="21px"
							height="14px"
						/>
					</BlackButton>
				</Form>
			</CenterContainer>
		</Body>
	)
}

export default ForgotPassword
